import React from "react";

function ChidoMapIframe() {
  const mapUrl =
    "//umap.openstreetmap.fr/en/map/carte-chido-mayotte_1154695?scaleControl=false&miniMap=false&scrollWheelZoom=false&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true";
  const fullScreenUrl =
    "//umap.openstreetmap.fr/en/map/carte-chido-mayotte_1154695?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&editMode=disabled&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=none&captionBar=false&captionMenus=true";

  return (
    <div className="map-container">
      <p>
        <p className="map-description">
          Pour contribuer à la carte Chido Mayotte : <br /> - Rejoindre le
          groupe WhatsApp :{" "}
          <a
            href="https://chat.whatsapp.com/LZVA0Ip0yUyLA2q6ayDtbk"
            target="_blank"
            rel="noopener noreferrer"
          >
            WhatsApp <br />
          </a>{" "}
          - Rejoindre le groupe Discord Situation Mayotte :{" "}
          <a
            href="https://discord.gg/7b8kA6MhWt"
            target="_blank"
            rel="noopener noreferrer"
          >
            Discord
          </a>{" "}
          canal infos-géographiques-mayottte
        </p>
        <p className="map-realisation">Réalisée par Eddine Omar</p>
        <a
          href={fullScreenUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="full-screen-link"
        >
          Voir en plein écran
        </a>
      </p>
      <iframe
        width="100%"
        height="700px"
        frameBorder="0"
        allowFullScreenz
        allow="geolocation"
        src={mapUrl}
        title="Carte CHIDO Mayotte"
      />
    </div>
  );
}

export default ChidoMapIframe;
